import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Form, Table, Image } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddCategory = ({ showModal, handleClose, fetchAllCategory, fetchAllNavCategory }) => {
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    const initialValues = {
        cat_name: "",
        cat_description: "",
        cat_img: null,
        created_by: sessionStorage.getItem("pk_user_key"),
    };

    const basicSchema = Yup.object().shape({
        cat_name: Yup.string()
            .required("Category Name is required.")
            .test("no-leading-space", "No spaces allowed at the beginning.", function (value) {
                if (!value) return true;
                return !/^\s/.test(value);
            })
            .matches(/^[a-zA-Z0-9\s]*$/, "Special characters are not allowed.")
            .min(3, "Category Name must be at least 3 characters.")
            .max(250, "Category Name must be at most 250 characters.")
            .test("no-trailing-space", "No spaces allowed at the end.", function (value) {
                if (!value) return true;
                return !/\s$/.test(value);
            })
            .test("no-numbers", "Category Name should not contain numbers.", function (value) {
                if (!value) return true;
                return !/\d/.test(value);
            })
            .test("unique-link", "Category Name is already existing in the database", async function (value) {
                if (!value) return true;
                return await checkCategoryName(value);
            })
            .strict(),

        cat_description: Yup.string()
            .required("Category Description is required.")
            .test("no-leading-space", "No spaces allowed at the beginning.", function (value) {
                if (!value) return true;
                return !/^\s/.test(value);
            })
            // .matches(/^[^\s].*[^\s]$/, "No spaces allowed at the beginning or end.")
            // .matches(/^[^\s].*[^\s]$/, "Leading or trailing spaces are not allowed.")
            .matches(/^[a-zA-Z0-9\s]*$/, "Special characters are not allowed.")
            .min(10, "Category Description must be at least 10 character.")
            .max(250, "Category Description must be at most 250 characters.")
            .test("no-trailing-space", "No spaces allowed at the end.", function (value) {
                if (!value) return true;
                return !/\s$/.test(value);
            })
            // .matches(
            //     /^[a-zA-Z][a-zA-Z\s.]*[a-zA-Z.]$/,
            //     "Category Description should only contain letters, spaces, and periods, and should not start or end with a space or period."
            // )
            .strict(),
        cat_img: Yup.mixed()
            .required("Category Image is required.")
            .test("fileType", "Unsupported File Format", (value) => {
                // Define supported image formats
                const supportedFormats = ["image/jpeg", "image/png", "image/gif"];
                return value ? supportedFormats.includes(value.type) : false;
            })
            .test("fileSize", "File size must be less than 2MB", (value) => {
                const maxSize = 2 * 1024 * 1024; // 2MB in bytes
                return value ? value.size <= maxSize : false;
            }),
    });

    async function checkCategoryName(cat_name) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkCategoryName",
            cat_name: cat_name,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();

            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "addCategory",
                    ...formValues,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output == 1) {
                resetFormFields(resetForm, setValues, initialValues);
                handleClose();
                fetchAllCategory();
                fetchAllNavCategory();
                toast.success("Added successfully!", {
                    autoClose: 3000,
                });
            } else {
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });

    // Now, you can set variables as needed:
    const values = formik.values;
    const handleBlur = formik.handleBlur;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const errors = formik.errors;
    const handleSubmit = formik.handleSubmit;
    const setFieldValue = formik.setFieldValue;
    const setTouched = formik.setTouched;
    const resetForm = formik.resetForm;
    const setValues = formik.setValues;
    const handleReset = formik.handleReset;
    return (
        <>
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Category</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit} ref={formRef}>
                        <Form.Group controlId="cat_img" className="mb-3">
                            <Form.Label>
                                Category Image <span className="text-danger">*</span>
                            </Form.Label>

                            <Form.Control
                                type="file"
                                onChange={(event) => {
                                    setFieldValue("cat_img", event.currentTarget.files[0]);
                                }}
                                onBlur={handleBlur}
                                accept="image/*"
                            />
                            {errors.cat_img && touched.cat_img && <p className="text-danger">{errors.cat_img}</p>}
                        </Form.Group>

                        <Form.Group controlId="cat_name" className="mb-3">
                            <Form.Label>
                                Category Name <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Form.Control type="text" value={values.cat_name} onChange={handleChange} onBlur={handleBlur} placeholder="Enter category name" />
                            {errors.cat_name && touched.cat_name && <p className="text-danger">{errors.cat_name}</p>}
                        </Form.Group>
                        <Form.Group controlId="cat_description" className="mb-3">
                            <Form.Label>
                                Description <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                // type="text"
                                as="textarea"
                                rows={3}
                                value={values.cat_description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter category description"
                            />
                            {errors.cat_description && touched.cat_description && <p className="text-danger">{errors.cat_description}</p>}
                        </Form.Group>

                        <div className="mt-3">
                            <Button variant="dark" type="submit" disabled={isSubmitting}>
                                Create Category
                            </Button>
                            <Button variant="outline-secondary" className="ms-2" onClick={handleClose}>
                                Cancel
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddCategory;
